import { apiRequest } from "../services/apiRequest"
import { api } from "../services/axios"

export const Discounts = {
  getDiscountsList: async ({
    code = "",
    status = "",
    plan = "",
    page = 1,
    pageSize = 10,
    localTimezone = null,
  } = {}) => {
    const queryParams = new URLSearchParams()

    if (code) queryParams.set("code", code)
    if (status && status !== "All Status") {
      // Convert "Active", "Expired", "Upcoming" to lowercase for API
      const statusLower = status.toLowerCase()
      queryParams.set("status", statusLower)
    }
    if (plan && plan !== "All Plan Types") queryParams.set("plan", plan)
    queryParams.set("page", page)
    if (pageSize) queryParams.set("page_size", pageSize)

    // Get local timezone if not provided
    const timezone =
      localTimezone || Intl.DateTimeFormat().resolvedOptions().timeZone
    if (timezone) {
      queryParams.set("local_timezone", timezone)
    }

    const queryString = queryParams.toString()
    const url = `/account/discounts/${queryString ? `?${queryString}` : ""}`

    return await apiRequest("get", url)
  },

  createDiscount: async (payload) => {
    return await apiRequest("post", `/account/discounts/`, payload)
  },

  deleteDiscount: async (discountId) => {
    return await apiRequest("delete", `/account/discounts/${discountId}/`)
  },

  updateDiscount: async (discountId, payload) => {
    return await apiRequest("put", `/account/discounts/${discountId}/`, payload)
  },

  getDiscountById: async (discountId) => {
    return await apiRequest("get", `/account/discounts/${discountId}/`)
  },

  getDiscountDetails: async () => {
    return await apiRequest("get", `/account/discounts/get_details/`)
  },

  getDiscountUsers: async (discountId, page = 1, pageSize = 10) => {
    const queryParams = new URLSearchParams()
    queryParams.set("discount_id", discountId)
    queryParams.set("page", page)
    if (pageSize) queryParams.set("page_size", pageSize)

    const queryString = queryParams.toString()
    const url = `/account/discounts/get_discount_users/${
      queryString ? `?${queryString}` : ""
    }`

    return await apiRequest("get", url)
  },

  exportDiscountUsers: async (discountId) => {
    const queryParams = new URLSearchParams()
    queryParams.set("discount_id", discountId)
    queryParams.set("export", "true")

    const queryString = queryParams.toString()
    const url = `/account/discounts/get_discount_users/?${queryString}`

    // Use api directly for blob response
    return await api({
      method: "get",
      url: url,
      responseType: "blob", // Important for file downloads
    })
  },

  getUsersCount: async (countries = []) => {
    const queryParams = new URLSearchParams()
    if (countries && countries.length > 0) {
      // Filter out "All Countries" and join with space for URL encoding
      const countryCodes = countries
        .filter((c) => c !== "All Countries" && c !== "all")
        .join(" ")
      if (countryCodes) {
        queryParams.set("countries", countryCodes)
      }
    }
    const queryString = queryParams.toString()
    const url = `/account/discounts/users_count/${
      queryString ? `?${queryString}` : ""
    }`
    return await apiRequest("get", url)
  },

  getPlans: async () => {
     return await apiRequest("get", `/account/discounts/get_plans/`)
  },

  getUserList: async (
    discountId,
    country = null,
    status = null,
    name = null,
    plan = null,
    page = 1,
    pageSize = 10
  ) => {
    const params = []
    if (discountId) {
      params.push(`discount_id=${discountId}`)
    }
    if (country) {
      // Don't encode + sign, keep it as is for country
      params.push(`country=${country}`)
    }
    if (status) {
      params.push(`status=${encodeURIComponent(status)}`)
    }
    if (name) {
      params.push(`name=${encodeURIComponent(name)}`)
    }
    if (plan) {
      params.push(`plan=${encodeURIComponent(plan)}`)
    }
    // Add pagination parameters
    params.push(`page=${page}`)
    if (pageSize) {
      params.push(`page_size=${pageSize}`)
    }
    const queryString = params.length > 0 ? params.join("&") : ""
    const url = `/account/discounts/get_user_list/${
      queryString ? `?${queryString}` : ""
    }`
    return await apiRequest("get", url)
  },

  getCountryFilter: async () => {
    return await apiRequest("get", `/account/discounts/get_country_filter/`)
  },
}
